var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-flex',{staticClass:"pa-0 ma-0 hidden-sm-and-down",attrs:{"xl6":"","lg6":"","md6":"","sm6":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',[_c('v-img',{staticClass:"container-image-fixed align-image",attrs:{"position":"center","src":_vm.loginPageImage}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }